import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'were_terminations_of_trade_union_officials_if_any_in_line_w_app'

export const dataPointDefinition = {
  retracedId: 'were_terminations_of_trade_union_officials_if_any_in_line_w_app',
  name: 'Were terminations of trade union official(s) (if any) in line with applicable legal requirements?',
  description:
    'Union presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf trade union officials were terminated, but there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nIf no trade union officials were terminated, select the answer: Not applicable. No trade union officials were terminated.\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-nana-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-nana-nalr',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-nana-nalr',
    },
    {
      name: 'Not applicable. No trade union officials were terminated.',
      key: 'NOT_APPLICABLE_NO_TRADE_UNION_OFFICIALS_WERE_TERMINATED',
      slcpIndex: 4,
      slcpOptionName: 'union-nana-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 5,
      slcpOptionName: 'union-nana-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'YES',
          'NO',
          'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
          'NOT_APPLICABLE_NO_TRADE_UNION_OFFICIALS_WERE_TERMINATED',
          'NO_APPLICABLE_LEGAL_REQS',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-37',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12280,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
